import { JSX, ComponentChild }		from "preact";
import { useRef, useId, useEffect }	from "preact/hooks";

import { NotUndefined }	from "ts-base/notUndefined";
import { Dom }			from "ts-base/web/dom";

import { EditorEdit }	from "@v3/geko/form/field";
import { FieldError }	from "@v3/geko/form/FieldError";
import {
	TextSchema,
	TextModel,
	TextState,
}	from "@v3/geko/form/textFieldModel";

export type AreaFieldProps	= {
	label:			string,
	hint?:			ComponentChild,
	placeholder:	string,
	missing:		string,
	invalid:		string,
	schema:			TextSchema,
	model:			TextModel,
	onEdit:			(edit:EditorEdit<TextState>)=>void,
	requestFocus?:	boolean,
};

export const AreaField	= ({ label, hint, placeholder, missing, invalid, schema, model, onEdit, requestFocus }:AreaFieldProps):JSX.Element	=> {
	const uid	= useId();

	const focusRef	= useRef<HTMLTextAreaElement>(null);
	useEffect(
		() => {
			if (requestFocus === true) {
				focusRef.current?.focus();
			}
		},
		[ requestFocus ]
	);

	return (
		<div class={Dom.classes(
			"FormField",
			"FormField--area",
			schema.required			&& "FormField--required",
			schema.showError(model)	&& "FormField--invalid",
		)}>
			<label class="FormField-label input-label" for={uid}>{label}</label>
			<div class="FormField-wrapper">
				<div class="FormField-editor">
					<textarea
						id={uid}
						ref={focusRef}
						class="FormField-focusTarget FormField-error-outline input-textarea"
						placeholder={placeholder}
						required={schema.required}
						value={model.value}
						onInput={ (ev) =>
							onEdit({ value: ev.currentTarget.value, touching: false })
						}
						onChange={ (ev) =>
							onEdit({ value: ev.currentTarget.value, touching: true })
						}
						autocomplete="off"
						spellcheck={false}
					/>
					{
						(schema.required || schema.restricted) &&
						<FieldError
							forId={uid}
							problem={schema.problem(model)}
							missing={missing}
							invalid={invalid}
						/>
					}
				</div>
				{ NotUndefined.is(hint) &&
					<div class="FormField-hint">{hint}</div>
				}
			</div>
		</div>
	);
};
